import { toast } from 'sonner';
import i18n from 'i18n';
import { useAppStore } from '../store/appStore';
import { useAuthStore } from '../store/authStore';
import { useProductStore } from '../store/productStore';
import { useReceiptStore } from '../store/receiptStore';
import { useTrackingStore } from '../store/trackingStore';
import { submitDisposition } from '../services/api/deposit';
import { ScreenType, SubmitApiResult } from '../types';
import { SCREEN_TYPES } from 'utils/constants';
import { playCallbackSound, playErrorSound, playGoodSound, playHoldSound } from './sounds';

export const handleProblemResolve = async (currentScreen: ScreenType): Promise<SubmitApiResult> => {
  const { user, stationId } = useAuthStore.getState();
  const { receiptData, setReceiptData } = useReceiptStore.getState();
  const { currentProduct: productLine, setCurrentProduct } = useProductStore.getState();
  const { setCurrentScreen } = useAppStore.getState();
  const { setLastTrackingId, setLastRmaId } = useTrackingStore.getState();

  try {
    let payload = {
      user_id: user.id,
      station_id: stationId,
      transaction_id: receiptData?.transaction_id || receiptData?.receipt?.transaction_id,
      problem_reason_msg: `Unexpected item scanned - Product: ${productLine?.product_id || 'Unknown'}`,
    };

    if (currentScreen === SCREEN_TYPES.SCAN_ITEM) {
      if (productLine) {
        // If an item is scanned, use item-specific reason
        if (productLine.exception_process === 'callback') {
          payload.problem_reason_msg = `Item requires callback - Grade: ${productLine.receipt_grade}`;
          playCallbackSound();
        } else if (productLine.exception_process === 'hold') {
          payload.problem_reason_msg = `Item on hold for review - Grade: ${productLine.receipt_grade}`;
          playHoldSound();
        } else {
          payload.problem_reason_msg = `Item disposition: ${productLine.disposition_stage}`;
          playErrorSound();
        }
      } else {
        // If no item scanned, mark receipt as having problem
        payload.problem_reason_msg = 'Receipt has problem';
      }
    }

    if (currentScreen === SCREEN_TYPES.SCAN_ITEM || currentScreen === SCREEN_TYPES.CONFIRM_ITEM) {
      const result = await submitDisposition(payload);
      if (result?.responseState === 'confirmed') {
        toast.success(i18n.t('toast.problemReportedSuccess'));

        // Clear all receipt-related data when marking as problem
        setCurrentProduct(null);
        setReceiptData(null);
        setLastTrackingId(null);
        setLastRmaId(null);

        // Always go to SCAN_BOX page after marking as problem
        setCurrentScreen(SCREEN_TYPES.SCAN_BOX);
        playGoodSound();
        return { success: true };
      } else {
        toast.error(result?.responseMsg || i18n.t('toast.failedReportProblem'));
        playErrorSound();
        return { success: false };
      }
    }
  } catch {
    toast.error(i18n.t('toast.networkError'));
    playErrorSound();
    return { success: false };
  }
};
